export default "__VITE_ASSET__C1AzDeK2__"